import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export default makeStyles({
  didYouKnow: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      paddingLeft: 50
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 'unset',
      alignItems: 'center',
      flexDirection: 'column'
    }
  }
})
